/**
 * Describes the parameters of a given search in pre-query, such as the query string
 */

/**
 * Describes the parameters of a given search in post query, such as the query string
 */

export const EMPTY_SEARCH_ITEMS = {
  size: 0,
  sections: []
};

/**
 * This is a component which can be used for transforming search results before the final output is rendered in the dialog.
 */